export * from './lib/copy-to-clipboard/copy-to-clipboard'
